<template>
    <div>
        <table class="mobileTable">
            <thead>
            <tr>
                <th>姓名</th>
                <th>小计</th>
                <th v-for="(item,key) in group_data_CateDesc">{{ item.desc }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,key,index) in group_data_UserId" :class="index%2==0?'stripe':''">
                <td>{{ getName(key) }}</td>
                <td>{{ getSubTotal(key) }}</td>
                <td v-for="(item,key2) in group_data_CateDesc">{{ getValue(key, item.desc) }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td>合计</td>
                <td>{{getTotal()}}</td>
                <td v-for="(item,key2) in group_data_CateDesc">{{ item.value }}</td>
            </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            group_data_CateDesc: [],
            group_data_UserId: {},
            StdQuery: [],
            StdQuerySum: {}

        }
    },
    created() {
        this.get_data()
    },
    methods: {
        getTotal() {
            let _counts = 0
            for (let i = 0; i < this.group_data_CateDesc.length; i++) {
                _counts += this.group_data_CateDesc[i].value
            }
            return _counts
        },
        getSubTotal(userId) {
            let _counts = 0
            let _row = this.StdQuery.filter(x => x.UserId == userId)
            for (let i = 0; i < _row.length; i++) {
                _counts += _row[i].Coutns
            }
            return _counts
        },
        getName(userId) {
            return this.StdQuery.filter(x => x.UserId == userId)[0].Name
        },
        getValue(userId, cateDesc) {
            let _data = this.StdQuery.filter(x => x.UserId == userId && x.CateDesc == cateDesc)

            if (_data.length == 0) {
                return 0
            } else if (_data[0].Coutns) {
                return _data[0].Coutns
            } else {
                return 0
            }
        },
        async get_data() {
            let _data = await this.$frame.getStdQueryData("UserIndustryReport")
            this.StdQuerySum = _data.StdQuerySum
            let _group_keyValue = this.$utils.groupBy(_data.StdQuery, ["CateDesc"], (cur, data2) => {
                return cur + data2.Coutns;
            })

            let _group_data_list = []
            for (let _key in _group_keyValue) {
                _group_data_list.push({desc: _key, value: _group_keyValue[_key]})
            }
            this.group_data_CateDesc = this.$utils.orderBy(_group_data_list, ["value"], "desc").results

            this.group_data_UserId = this.$utils.groupBy(_data.StdQuery, ["UserId"], (cur, data2) => {
                return cur + 1;
            })
            this.StdQuery = _data.StdQuery
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
